/*=========================================================================================
  File Name: moduleCategoryMutations.js
  Description: Category Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";

export default {
	SET_STANDARD_INPUT(state, items) {
		state.standardInputList = items;
	},
	SET_STANDARD_INPUT_NAME(state, name) {
		state.standardInputList["name"] = name;
	},
	DELETE_VISIT_POINTS_SELECTED_PICKUP_STANDARD_INPUT(state, item) {
		const ItemIndex = state.standardInputList["pickups"].findIndex(
			(p, index) => p.identification === item.visitPoint.identification && index === item.indexVisitPoint
		);
		state.standardInputList["pickups"].splice(ItemIndex, 1);
	},
	DELETE_VISIT_POINTS_SELECTED_DELIVERY_STANDARD_INPUT(state, item) {
		const ItemIndex = state.standardInputList["deliveries"].findIndex(
			(p, index) => p.identification === item.visitPoint.identification && index === item.indexVisitPoint
		);
		state.standardInputList["deliveries"].splice(ItemIndex, 1);
	},
	ADD_OPTIMIZATION(state, item) {
		state.optimizationList.unshift(item);
	},
	SET_OPTIMIZATION(state, items) {
		state.optimizationList = [...items];
	},
	REMOVE_OPTIMIZATION(state, itemId) {
		const ItemIndex = state.optimizationList.findIndex((p) => p.id === itemId);
		state.optimizationList.splice(ItemIndex, 1);
	},
	REMOVE_ALL_OPTIMIZATION(state, itemId) {
		state.optimizationList = [];
	},
	SET_OPTIMIZATION_EDIT(state, items) {
		state.optimizationEditList = items;
	},
	UPDATE_OPTIMIZATION(state, optimization) {
		const optimizationIndex = state.optimizationList.findIndex((p) => p.id === optimization.id);
		if (optimizationIndex !== -1) {
			Object.assign(state.optimizationList[optimizationIndex], optimization);
		}
	},
	SET_VISIT_POINT_STANDARD_INPUT_PICKUP(state, items) {
		const currentPickups = state.standardInputList["pickups"] || [];
		const newItems = items.filter(
			(item) => !currentPickups.some((existing) => existing.identification === item.identification)
		);
		state.standardInputList["pickups"] = currentPickups.concat(newItems);
	},
	SET_VISIT_POINT_STANDARD_INPUT_DELIVERY(state, items) {
		let arrayNew = state.standardInputList["deliveries"].concat(
			items.filter(
				(element) =>
					state.standardInputList["deliveries"].find((e) => e.identification === element.identification) ===
					undefined
			)
		);
		state.standardInputList["deliveries"] = arrayNew;
	},
	UPDATE_VISIT_POINT_STANDARD_INPUT_PICKUP(state, visitPoint) {
		const visitPointIndex = state.standardInputList["pickups"].findIndex(
			(p) => p.identification === visitPoint.identification
		);
		if (visitPointIndex !== -1) {
			state.standardInputList["pickups"][visitPointIndex] = visitPoint;
		}
	},
	UPDATE_VISIT_POINT_STANDARD_INPUT_DELIVERY(state, visitPoint) {
		const visitPointIndex = state.standardInputList["deliveries"].findIndex(
			(p) => p.identification === visitPoint.identification
		);
		if (visitPointIndex !== -1) {
			state.standardInputList["deliveries"][visitPointIndex] = visitPoint;
		}
	},
	SET_VEHICLE_STANDARD_INPUT(state, items) {
		let arrayNew = state.standardInputList["vehicles"].concat(
			items.filter(
				(element) =>
					state.standardInputList["vehicles"].find((e) => e.identification === element.identification) ===
					undefined
			)
		);
		state.standardInputList["vehicles"] = arrayNew;
	},
	UPDATE_VEHICLE_STANDARD_INPUT(state, item) {
		const vehicleIndex = state.standardInputList["vehicles"].findIndex(
			(p) => p.identification === item.identification
		);
		if (vehicleIndex !== -1) {
			state.standardInputList["vehicles"][vehicleIndex] = item;
		}
	},
	DELETE_VEHICLE_SELECTED_STANDARD_INPUT(state, item) {
		const ItemIndex = state.standardInputList["vehicles"].findIndex(
			(p, index) => p.identification === item.resource.identification && index === item.indexResource
		);
		state.standardInputList["vehicles"].splice(ItemIndex, 1);
	},
	SET_SCHEDULE_DATARUTAS(state, items) {
		state.scheduleList = items;
	},
	DELETE_VISIT_POINTS_SELECTED_SCHEDULE_DATARUTAS(state, item) {
		const ItemIndex = state.scheduleList["events"].findIndex((p) => p.index === item);
		state.scheduleList["events"].splice(ItemIndex, 1);
	},
	DELETE_ALL_VISIT_POINTS_SELECTED_SCHEDULE_DATARUTAS(state) {
		state.scheduleList = [];
	},
	SET_SCHEDULE_DATARUTAS_WAYPOINTS(state, items) {
		state.scheduleWayPointList = items;
	},
	DELETE_VISIT_POINTS_DATARUTAS_WAYPOINTS(state, item) {
		const ItemIndex = state.scheduleWayPointList["events"].findIndex((p) => p.index === item);
		state.scheduleWayPointList["events"].splice(ItemIndex, 1);
	},
	DELETE_ALL_VISIT_POINTS_DATARUTAS_WAYPOINTS(state) {
		state.scheduleWayPointList = [];
	},
	SET_ERROR_OPTIMIZATION(state, items) {
		state.errorList = items;
	},
	DELETE_ALL_ERROR_OPTIMIZATION(state) {
		state.errorList = [];
	},
	SET_COMPANY_OPTIMIZERS(state, items) {
		state.listCompanyOptimizers = items;
	},
	SET_ASSIGNED_PICKUP_JOBS(state, items) {
		let arrayNew = state.listSelectedPickupJobs.concat(
			items.filter(
				(element) =>
					state.listSelectedPickupJobs.find((identification) => identification === element) === undefined
			)
		);
		state.listSelectedPickupJobs = arrayNew;
	},
	REMOVE_ASSIGNED_PICKUP_JOBS(state, identification) {
		const itemIndex = state.listSelectedPickupJobs.findIndex((item) => item === identification);
		state.listSelectedPickupJobs.splice(itemIndex, 1);
	},
	REMOVE_ALL_ASSIGNED_PICKUP_JOBS(state) {
		state.listSelectedPickupJobs = [];
	},
	SET_ASSIGNED_DELIVERY_JOBS(state, items) {
		let arrayNew = state.listSelectedDeliveryJobs.concat(
			items.filter(
				(element) =>
					state.listSelectedDeliveryJobs.find((identification) => identification === element) === undefined
			)
		);
		state.listSelectedDeliveryJobs = arrayNew;
	},
	REMOVE_ASSIGNED_DELIVERY_JOBS(state, identification) {
		const itemIndex = state.listSelectedDeliveryJobs.findIndex((item) => item === identification);
		state.listSelectedDeliveryJobs.splice(itemIndex, 1);
	},
	REMOVE_ALL_ASSIGNED_DELIVERY_JOBS(state) {
		state.listSelectedDeliveryJobs = [];
	},
	SET_JOB_STANDARD_INPUT(state, items) {
		if (state.standardInputList.hasOwnProperty("jobs")) {
			let arrayNew = state.standardInputList["jobs"].concat(
				items.filter(
					(element) => state.standardInputList["jobs"].find((e) => e.name === element.name) === undefined
				)
			);
			Vue.set(state.standardInputList, "jobs", arrayNew);
		} else {
			Vue.set(state.standardInputList, "jobs", items);
		}
	},
	UPDATE_JOB_STANDARD_INPUT(state, item) {
		const itemIndex = state.standardInputList["jobs"].findIndex((p) => p.name === item.name);
		if (itemIndex !== -1) {
			state.standardInputList["jobs"][itemIndex] = item;
		}
	},
	DELETE_JOB_SELECTED_STANDARD_INPUT(state, item) {
		const ItemIndex = state.standardInputList["jobs"].findIndex((p) => p.name === item.name);
		state.standardInputList["jobs"].splice(ItemIndex, 1);
	},
	SET_UPLOAD_FILE_JOB(state, item) {
		state.uploadFileListJobs = [item];
		state.checkedUploadFilesJobs = [item];
	},
	REMOVE_UPLOAD_FILE_JOB(state, item) {
		const itemIndex = state.uploadFileListJobs.findIndex((p) => p.bucket_path === item.bucket_path);
		if (itemIndex >= 0) {
			state.uploadFileListJobs.splice(itemIndex, 1);
		}
		state.checkedUploadFilesJobs = [];
	},
	REMOVE_ALL_UPLOAD_FILE_JOB(state) {
		state.uploadFileListJobs = [];
	},
	ADD_CHECKED_UPLOAD_FILE_JOB(state, item) {
		state.checkedUploadFilesJobs.push(item);
	},
	REMOVE_CHECKED_UPLOAD_FILE_JOB(state, item) {
		const itemIndex = state.checkedUploadFilesJobs.findIndex((p) => p.bucket_path === item.bucket_path);
		if (itemIndex >= 0) {
			state.checkedUploadFilesJobs.splice(itemIndex, 1);
		}
	},
	REMOVE_ALL_CHECKED_UPLOAD_FILE_JOB(state) {
		state.checkedUploadFilesJobs = [];
	},
	SET_SCHEDULE_EVENTS_WAYPOINTS(state, events) {
		state.eventList = events.map((e) => {
			return {...e, calendarId: e.init_hour + e.id};
		});
	},
	REMOVE_ALL_EVENTS_WAYPOINTS(state) {
		state.eventList = [];
	},
	ADD_EVENTS_WAYPOINTS_CHECKED(state, item) {
		const itemIndex = state.checkedEvents.findIndex((p) => p.id === item.id);
		if (itemIndex === -1) {
			state.checkedEvents.push(item);
		}
	},
	SET_EVENTS_WAYPOINTS_CHECKED(state, items) {
		state.checkedEvents = items;
	},
	REMOVE_EVENTS_WAYPOINTS_CHECKED(state, item) {
		const itemIndex = state.checkedEvents.findIndex((p) => p.id === item.id);
		if (itemIndex >= 0) {
			state.checkedEvents.splice(itemIndex, 1);
		}
	},
	REMOVE_ALL_EVENTS_WAYPOINTS_CHECKED(state) {
		state.checkedEvents = [];
	},
};
